// src/pages/exercise/data/characterConfig.js
// Maps exerciseStore charIndex (1–4) to mood token, display name, and accent colour.
// moodToken must exactly match strings used in exercisePool.js moodMatch arrays.

export const CHARACTER_CONFIG = {
  1: {
    name: "Moose",
    emoji: "🦌",
    moodToken: "Moose Motivated",
    accentColor: "#C28A4B",
    tagline: "Let's go — you've got the drive.",
  },
  2: {
    name: "Bunny",
    emoji: "🐰",
    moodToken: "BunnyEnergetic",
    accentColor: "#E87F9A",
    tagline: "High energy, high reward.",
  },
  3: {
    name: "Sloth",
    emoji: "🦥",
    moodToken: "Sloth Calm",
    accentColor: "#6BAA75",
    tagline: "Slow and steady wins the race.",
  },
  4: {
    name: "Tiger",
    emoji: "🐯",
    moodToken: "Tiger Resilient",
    accentColor: "#D4793A",
    tagline: "Push through. You're built for this.",
  },
};